export default "__VITE_ASSET__CkpFxAVq__"